import { useCookies } from 'react-cookie';
import styled from 'styled-components';
import { cache } from 'swr';
import { Row, Col } from 'react-awesome-styled-grid';
import { useRouter } from 'next/router';
import { down, up } from 'styled-breakpoints';
import { P1 } from 'pfm-ui-components';
import Link from 'next/link';
import { pxToRem } from '../../../styles/utils';
import { routes } from '../../../config/routes';
import { useAppContext } from '../../../store';
import { CHANNEL_ID, CHANNEL_ID_TYPES, CUSTOMER_ID, CUST_ID, LAST_LOGIN, TOKEN } from '../../../constants/common';
import API from '../../../API';
import { getCookiesOptions } from '../../../utils/common';
import { useEffect, useState } from 'react';
import { StyledAlertModal } from '../../../pages/transact/invest';
import { unsetAuthToken } from '../../../API/utils';
import { decryptString } from '../../../utils/encrypt';
import { getFundCategoryBasedOnRouterPath } from '../../modules/transact/InvestPage/gtmUtil';
import GTM from '../../../GTM';
import { useDeviceType } from '../../../utils/deviceType';
import DEVICE_TYPE from '../../../constants/device';
import { getCookie } from '../../../GTM/utils';

export default function Header(props: { loginHeader?: boolean }) {
  const router = useRouter();
  const [cookie, setCookie, removeCookie] = useCookies();
  const { state, resetState, setState } = useAppContext();
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorMessageShownInModal, setErrorMessageShownInModal] = useState('');
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;

  const onLogoutClick = () => {
    API.login
      .logout()
      .then((res) => {
        const isCIB = getCookie(CHANNEL_ID) === CHANNEL_ID_TYPES.CIB;
        removeCookie(TOKEN, getCookiesOptions());
        removeCookie(CUSTOMER_ID, getCookiesOptions());
        removeCookie(LAST_LOGIN, getCookiesOptions());
        removeCookie(CUST_ID, getCookiesOptions());
        if (!isCIB) {
          removeCookie(CHANNEL_ID, getCookiesOptions());
        }
        unsetAuthToken();
        if (isCIB) {
          router.push('/cibLogout');
        } else {
          router.push(routes.LOGIN.url);
        }
        resetState();
        cache.clear();
        router.push(routes.LOGOUT.url);
        resetState();
      })
      .catch((err) => {
        setOpenErrorModal(true);
        setErrorMessageShownInModal(err?.errorMsg?.message);
      });
  };

  useEffect(() => {
    var cookieValue = getCookie(CHANNEL_ID);
    if (cookieValue !== '' && cookieValue !== undefined && cookieValue !== null) {
      API.customer
        .getProfile()
        .then((response: any) => {
          setState({
            ...state,
            customerAddress: response?.data?.data[0]?.address,
          });
        })
        .catch((err) => {
          setOpenErrorModal(true);
          setErrorMessageShownInModal(err?.errorMsg?.message);
        });
    }
  }, [getCookie(CHANNEL_ID)]);

  if (router.pathname === '/') return null;
  return (
    <HeaderContainer loginHeader={props.loginHeader}>
      {openErrorModal && (
        <StyledAlertModal
          className="alert-modal"
          wrapperClassname="alert-modal-wrapper"
          contentClassname="alert-modal-content"
          onClose={() => setOpenErrorModal(false)}
          mode="alert"
          showHeader={false}
        >
          <StyledP1>{errorMessageShownInModal}</StyledP1>
        </StyledAlertModal>
      )}
      <HeaderRibbonTopStrip />
      <HeaderRibbonContents isMobile={isMobile}>
        <HeaderRibbon isMobile={isMobile} />

        {isMobile ? (
          <AxisLogoIconWrapper top={8} left={8}>
            <img src="/images/axis-logo-icon.svg" />
          </AxisLogoIconWrapper>
        ) : (
          <AxisLogoIconWrapper top={21} left={97}>
            <img src="/images/axis-logo-full.svg" />
          </AxisLogoIconWrapper>
        )}

        <HeaderTitle>
          <Link
            href={
              cookie && getCookie(CHANNEL_ID) === CHANNEL_ID_TYPES.CIB
                ? ''
                : cookie[CUSTOMER_ID]
                ? routes.MUTUAL_FUND.url
                : routes.LOGIN.url
            }
          >
            <HeaderTitleTextWrapper>
              <img src="/images/OPEN.svg" />
              <HeaderTitleTextSeparator>|</HeaderTitleTextSeparator>
              <HeaderTitleText>MUTUAL FUNDS</HeaderTitleText>
            </HeaderTitleTextWrapper>
          </Link>

          <HeaderIconButtonWrapper>
            {!props.loginHeader && cookie[TOKEN] && (
              <>
                {cookie && cookie[CUSTOMER_ID] && !isMobile && (
                  <HeaderIconButtonBox>
                    <DesktopViewIconWrapper>
                      <img src="/images/user-icon.svg" />
                      <span>{cookie[CUST_ID]}</span>
                    </DesktopViewIconWrapper>
                  </HeaderIconButtonBox>
                )}

                {isMobile && (
                  <HeaderIconButtonBox
                    onClick={() => {
                      if (getCookie(CHANNEL_ID) === CHANNEL_ID_TYPES.CIB) {
                        router.push('/portfolioCIB');
                      } else {
                        GTM.mobileNavigation.onHomeIconClick(
                          getFundCategoryBasedOnRouterPath(window.location.pathname + window.location.search)
                        );
                        router.push('/mutualFunds');
                      }
                    }}
                  >
                    <img src="/images/header-home-icon.svg" />
                  </HeaderIconButtonBox>
                )}

                {cookie[TOKEN] && (
                  <HeaderIconButtonBox onClick={onLogoutClick}>
                    <img src="/images/logout-icon.svg" />
                    {!isMobile && (
                      <DesktopViewIconWrapper>
                        <span>Logout</span>
                      </DesktopViewIconWrapper>
                    )}
                  </HeaderIconButtonBox>
                )}
              </>
            )}
          </HeaderIconButtonWrapper>
        </HeaderTitle>
      </HeaderRibbonContents>
    </HeaderContainer>
  );
}

interface HeaderContainerType {
  loginHeader?: boolean;
}

const HeaderRibbonContents = styled.div<{ isMobile: boolean }>`
  display: flex;
  margin-top: ${(props) => (props.isMobile ? '0px' : '15px')};
  align-items: center;
`;
const HeaderTitleTextWrapper = styled.div`
  display: flex;
  gap: 6px;
  color: #97144d;
  cursor: pointer;
`;

const AxisLogoIconWrapper = styled.div<{ top: number; left: number }>`
  position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
`;

const HeaderRibbon = styled.div<{ isMobile: boolean }>`
  background-image: ${(props) => (props.isMobile ? `url(/images/axis-ribbon.svg)` : `url(/images/left-ribbon.svg)`)};
  background-position: left top;
  background-repeat: no-repeat;
  margin: 0;
  height: 45px;
  width: ${(props) => (props.isMobile ? `64px` : `203px`)};
`;
const HeaderRibbonTopStrip = styled.div`
  width: 100%;
  height: 15px;
  background-color: #97144d;
  position: absolute;
  top: 0;
  left: 0;
  ${down('sm')} {
    display: none;
  }
`;

const HeaderContainer = styled.div<HeaderContainerType>`
  width: 100%;
  background-color: white;
  position: fixed;
  top: 0;
  z-index: 99;

  ${up('md')} {
    background-size: 100% 100%;
  }
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  padding-right: 24px;
`;

const HeaderTitleTextSeparator = styled.span`
  font-size: ${pxToRem(11)};
  font-style: italic;
`;

const HeaderTitleText = styled(HeaderTitleTextSeparator)`
  display: block;
`;

const HeaderIconButtonWrapper = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;

const HeaderIconButtonBox = styled.div`
  display: flex;
  gap: 10px;
  font-size: ${pxToRem(14)};
  color: #97144d;
  cursor: pointer;
  align-items: center;
`;

const LogoutText = styled.div`
  padding-top: ${pxToRem(2)};
  padding-right: ${pxToRem(18)};
  font-size: ${pxToRem(12)};
  cursor: pointer;
  color: ${(props) => props.theme.palette.white};
`;

const HeaderFont = styled(LogoutText)`
  padding-top: ${pxToRem(2)};
  font-size: ${pxToRem(12)};
  padding-right: 0;
  cursor: auto;
  color: ${(props) => props.theme.palette.white};
`;

const StyledRow = styled(Row)`
  margin: 0;
  ${up('md')} {
    justify-content: flex-end;
  }
`;

const StyledMobileRow = styled(StyledRow)`
  position: absolute;
  right: 0;
  align-items: center;
`;

const StyledCol = styled(Col)`
  align-items: flex-start;
  flex-direction: revert;
  justify-content: flex-end;
`;

const IconWrapper = styled.div`
  margin-right: ${pxToRem(4)};
`;

const HomeIconWrapper = styled.div`
  margin-top: ${pxToRem(16)};
  width: 100%;
  text-align: end;
  ${up('md')} {
    display: none;
  }
`;

const DesktopViewIconWrapper = styled.div`
  padding-right: 15px;
  display: flex;
  align-items: center;
  justify content: center;
  gap: 10px;
`;

// If the login is done via MBK channelId then no header will be shown
// so return 0px or else if header is there return 60px i.e header height
export const useHeaderHeight = () => {
  const [headerHeight, setHeaderHeight] = useState(null);
  const { state } = useAppContext();
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;
  useEffect(() => {
    if (state.showHeader) {
      if (isMobile) setHeaderHeight('45px');
      else setHeaderHeight('60px');
    } else {
      setHeaderHeight('0px');
    }
  }, [state.showHeader]);

  return headerHeight;
};
export const useBottom = () => {
  const [bottom, setBottom] = useState(null);
  const { state } = useAppContext();
  useEffect(() => {
    if (state.showHeader) {
      setBottom('0px');
    } else {
      setBottom('12px');
    }
  }, [state.showHeader]);
  return bottom;
};

const StyledP1 = styled(P1)`
  color: ${(props) => props.theme.palette.grey2};
`;
